module.exports = __webpack_public_path__ + "img/logo-m202109021.944bb5c9.png";